import { PROVIDER_MULTI_VERTICAL_ROUTES } from '@/constants';
import {
  getCaregiverProfileCompleteness,
  getCaregiverProfileCompletenessVariables,
} from '@/__generated__/getCaregiverProfileCompleteness';
import { MultipleVerticalsTypes } from '@/__generated__/globalTypes';
import { useLazyQuery } from '@apollo/client';
import router from 'next/router';
import { useEffect } from 'react';
import { useProviderMVState } from '../AppState';
import { GET_CAREGIVER_ENROLLMENT_STATUS } from '../request/GQL';
import useMultiVerticalServiceTypes from './useMultiVerticalServiceTypes';

const useMultiVerticalRedirect = () => {
  const { serviceType } = useProviderMVState();
  const { APP_DOWNLOAD, RATE_CARD, SERVICES } = PROVIDER_MULTI_VERTICAL_ROUTES;
  const mapVerticalToServiceType = useMultiVerticalServiceTypes();

  const [loadCaregiverCompleteness, { loading, data: completenessData }] = useLazyQuery<
    getCaregiverProfileCompleteness,
    getCaregiverProfileCompletenessVariables
  >(GET_CAREGIVER_ENROLLMENT_STATUS);

  const redirectToEnrollmentStep = () => {
    loadCaregiverCompleteness({
      variables: {
        serviceType: mapVerticalToServiceType(serviceType as MultipleVerticalsTypes),
      },
    });
  };

  useEffect(() => {
    const caregiverProfile = completenessData?.getCaregiverProfileCompleteness;
    if (caregiverProfile !== undefined) {
      const { subscriptionPurchased, hourlyRatesUpdated, subscriptionPlanViewed } =
        caregiverProfile;
      if (!hourlyRatesUpdated && !subscriptionPlanViewed && !subscriptionPurchased) {
        router.push(SERVICES);
      } else if (subscriptionPurchased) {
        router.push(APP_DOWNLOAD);
      } else if (subscriptionPlanViewed) {
        window.location.assign(`${window.location.origin}${RATE_CARD}`);
      } else {
        window.location.assign(`${window.location.origin}${RATE_CARD}`);
      }
    }
  }, [loading]);

  return { redirectToEnrollmentStep };
};

export default useMultiVerticalRedirect;
